import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_18: FaireProductEntity = {
  token: "legacy_prod_abbott-18",
  type: "product",
  name: 'Sand LED Ball Candle 4" D',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/2adde0d36bd354f3bf904823a65e6c4e287743b25c9bbdc4160cde7aaebd8ffd.jpeg",
  priceDollars: 18,
  msrpDollars: 36,
  subcategory: "Ball & Votive",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_candles-holders"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
